













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Clipboard from 'clipboard'

import { User } from '../../../store/user/types'

@Component
export default class UserTransitionDialog extends Vue {
  @Prop() user!: User
  @Prop() show!: boolean
  clipboard = new Clipboard('.clipboard')
  copied = false
  timeout = 1000
  timerId: number | null = null

  mounted() {
    this.clipboard.on('success', e => {
      this.copied = true
      e.clearSelection()
    })
  }

  @Watch('copied')
  setTimer() {
    if (!this.copied) return
    if (this.timerId) clearTimeout(this.timerId)
    this.timerId = setTimeout(() => {
      this.copied = false
    }, this.timeout)
  }

  handleAccept() {
    this.$emit('click:accept')
  }

  handleClose() {
    this.$emit('close')
  }
}
